import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  ImageBaseWrapper
} from './styled'

export class ImageBase extends React.PureComponent {
  render() {
    const {
      // Option
      className,
      // Default
      top,
      left,
      widthRatio,
      widthRatioUnit,
      heightRatio,
      heightRatioUnit,
      borderRadius,
      src,
      alt,
      title,
      onClick,
      contain
    } = this.props

    return (
      <ImageBaseWrapper
        className={ClassNames(
          'image-base',
          { 'is-cursor-pointer': onClick },
          { 'is-contain': contain },
          // Option
          className
        )}
        theme={{
          // Default
          top,
          left,
          widthRatio,
          widthRatioUnit,
          heightRatio,
          heightRatioUnit,
          borderRadius
        }}
        title={title}
        onClick={onClick}
      >
        <img className='image-ratio-base'
          src={src}
          alt={alt}
        />
      </ImageBaseWrapper>
    )
  }

  static defaultProps = {
    widthRatio: '100',
    widthRatioUnit: '%',
    heightRatio: '57',
    heightRatioUnit: '%'
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    left: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    widthRatio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    widthRatioUnit: PropTypes.string,
    heightRatio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    heightRatioUnit: PropTypes.string,
    borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    src: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }
}
